import Button from '@nebula/button';
import { BodyMedium400 } from '@nebula/global-styles';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 90px);

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    height: calc(100vh - 100px);
  }

  @media ${({ theme }) => theme.media.tabletLandscapeMin} {
    width: 802px;
    margin: 0 auto;
    height: calc(100vh - 184px);
  }
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  text-align: center;
  max-width: 346px;
`;

export const IconContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  gap: 8px;
`;

export const StyledTitleSmall500 = styled.h1`
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  margin: 0;
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const StyledBodyMedium400 = styled(BodyMedium400)`
  font-size: 14px;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.color.ui.grey[90]};
`;

export const BackHomeButton = styled(Button)`
  margin-top: 16px;
  background-color: ${({ theme }) => theme.color.decorative.magenta[70]} !important;
  border: none;
  font-size: 14px;
  > span {
    line-height: 20px;
  }
`;
